import * as microsoftTeams from '@microsoft/teams-js';
import { useEffect, useState } from 'react';

type TeamsContext = Partial<microsoftTeams.app.Context>;
type UseTeamsSdk = { isTeamsReady: boolean; userContext: TeamsContext };

/** Arranca el SDK de Teams una vez y da su contexto; lo comparten las pestañas de Teams de app y de Edelvives. */
function useTeamsSdk(): UseTeamsSdk {
  const [isTeamsReady, setIsTeamsReady] = useState<boolean>(false);
  const [userContext, setUserContext] = useState<TeamsContext>({});

  useEffect(() => {
    let isMounted = true;
    microsoftTeams.app
      .initialize()
      .then(() => {
        if (!isMounted) return;
        setIsTeamsReady(true);
        return microsoftTeams.app.getContext().then((context) => {
          if (isMounted) setUserContext(context);
        });
      })
      .catch(() => {
        // Fuera del cliente de Teams el SDK rechaza a los 60 s («SDK initialization timed out»,
        // TANGERINE-FRONTOFFICE-571): no hay pestaña que configurar y el contexto queda vacío.
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return { isTeamsReady, userContext };
}

export default useTeamsSdk;
